import { useCallback } from 'react';
import useUiuxStore from 'src/store/useUiuxStore';
import { initializeTabStore } from './storeInitializer';

export const TabUtils = () => {
	const { tabList, activeTab, removeTabList } = useUiuxStore();
	
	const handleExitClick = useCallback((key: string) => {
		const closingTab = tabList.find(tab => tab.key === key);
		if (closingTab?.fixed) {
			alert("이 탭은 닫을 수 없습니다.");
			return;
		}

		if (tabList.length === 1) {
			alert('탭이 하나만 남았을 때는 닫을 수 없습니다.');
			return;
		}
		if (activeTab === undefined) {
			alert('활성화된 탭이 없습니다.');
			return;
		}

		// 공통 초기화 함수 사용
		initializeTabStore(key);
		
		// 탭 제거
		removeTabList(key);
	}, [tabList, activeTab, removeTabList]);

	return {
		handleExitClick
	}
};




